import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
      } catch { /* retry */ }
      tries += 1;
      if (tries < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <main data-testid="payment-success-page" className="pt-40 pb-32 min-h-screen">
      <Seo title="Payment — Bahare" description="Workshop registration payment." />
      <div className="max-w-md mx-auto px-6 text-center">
        {status === "checking" && (
          <Reveal>
            <p className="font-serif text-4xl mb-4">Confirming your payment…</p>
            <p className="text-sm text-[#4A4A4A]">One moment please.</p>
          </Reveal>
        )}
        {status === "paid" && (
          <Reveal>
            <p className="font-serif text-4xl mb-4" data-testid="payment-confirmed">Your seat is confirmed.</p>
            <p className="text-sm text-[#4A4A4A] leading-relaxed mb-10">
              Payment received — thank you. You'll get a confirmation email with all the details.
            </p>
            <Link to="/workshops" className="text-[11px] uppercase tracking-[0.22em] border-b border-[#1A1A1A] pb-1">Back to Workshops</Link>
          </Reveal>
        )}
        {status === "pending" && (
          <Reveal>
            <p className="font-serif text-4xl mb-4">Almost there.</p>
            <p className="text-sm text-[#4A4A4A] leading-relaxed mb-10">
              Your payment is being processed — you'll receive an email as soon as it confirms.
            </p>
            <Link to="/workshops" className="text-[11px] uppercase tracking-[0.22em] border-b border-[#1A1A1A] pb-1">Back to Workshops</Link>
          </Reveal>
        )}
        {status === "error" && (
          <Reveal>
            <p className="font-serif text-4xl mb-4">Something's missing.</p>
            <Link to="/workshops" className="text-[11px] uppercase tracking-[0.22em] border-b border-[#1A1A1A] pb-1">Back to Workshops</Link>
          </Reveal>
        )}
      </div>
    </main>
  );
}
